import { CButton } from "@coreui/react"
import { Switch, DatePicker, Button } from "antd"
import React, { useState } from "react"
import { DeleteOutlined, DownOutlined } from "@ant-design/icons"

const TableTitle = ({
  onClickOpenModal,
  onClickOpenModalCreate,
  showDeletedItems,
  isDeleted,
  mnemoButton,
  mnemoSwitcher,
  mnemoButtonCreate,
  handleChangeDate = false,
}) => {
  const { RangePicker } = DatePicker

  return (
    <div
      style={{
        background: "#fff",
        borderRadius: "8px",
        marginBottom: 0,
        overflow: "hidden",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          background: "#fff",
          userSelect: "none",
          minHeight: "60px",
          padding: "0 16px",
        }}
      >
        <div
          style={{
            flex: 1,
            display: "flex",
            alignItems: "center",
            gap: "12px",
            flexWrap: "wrap",
          }}
        >
          <div
            style={{ fontSize: "16px", fontWeight: 500, color: "#262626" }}
          ></div>
        </div>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            marginLeft: "20px",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            {handleChangeDate ? (
              <RangePicker
                placeholder={`Выбрать дату`}
                onChange={(e) => {
                  handleChangeDate(e)
                }}
                style={{ height: "34px" }}
              />
            ) : (
              <>
                {!mnemoSwitcher && (
                  <Switch
                    checkedChildren={<DeleteOutlined />}
                    unCheckedChildren={<DeleteOutlined />}
                    onChange={(e) => showDeletedItems(e)}
                    disabled={mnemoSwitcher}
                    style={{ transform: "scale(1.1)" }}
                  />
                )}
                {mnemoButtonCreate?.show && (
                  <CButton
                    disabled={isDeleted || mnemoButtonCreate.mnemo}
                    onClick={onClickOpenModalCreate}
                    size='sm'
                    className='text-light'
                    style={{
                      height: "34px",
                      minWidth: "140px",
                      fontSize: "15px",
                      fontWeight: "500",
                      borderRadius: "6px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "8px",
                      boxShadow: "0 2px 0 rgba(0,0,0,0.045)",
                    }}
                  >
                    Создать пакеты
                  </CButton>
                )}
                <CButton
                  disabled={isDeleted || mnemoButton}
                  onClick={onClickOpenModal}
                  size='sm'
                  className='text-light'
                  style={{
                    height: "34px",
                    minWidth: "100px",
                    fontSize: "15px",
                    fontWeight: "500",
                    borderRadius: "6px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "8px",
                    boxShadow: "0 2px 0 rgba(0,0,0,0.045)",
                  }}
                >
                  Добавить
                </CButton>
               
              </>
            )}
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              minWidth: "40px",
            }}
          >
            <Button
              type='text'
              icon={<DownOutlined />}
              style={{
                width: "40px",
                height: "40px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "16px",
                color: "#8c8c8c",
              }}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default TableTitle
